// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".c-linear-schedule{display:flex;flex-direction:column;min-height:0}.c-linear-schedule .bucket{padding-top:8px}.c-linear-schedule .bucket .bucket-label{font-size:14px;font-weight:500;color:rgba(0,0,0,.54);padding-left:16px}.c-linear-schedule .bucket .break{z-index:10;margin:8px;padding:8px;border-radius:4px;background-color:#eee;display:flex;justify-content:center;align-items:center}.c-linear-schedule .bucket .break .title{font-size:20px;font-weight:500;color:rgba(0,0,0,.54)}", ""]);
// Exports
module.exports = exports;
